interface CurrencyInfo {
  code: string;
  symbol: string;
}

export const getCurrencyInfo = (countryCode: string | undefined): CurrencyInfo => {
  if (!countryCode) {
    return { code: 'Currency not available', symbol: 'Currency not available' };
  }

  let currencyInfo: CurrencyInfo = {
    code: 'Currency not available',
    symbol: 'Currency not available',
  };

  // Determine currency info based on country using switch-case
  switch (countryCode) {
    case 'cz':
      currencyInfo = { code: 'CZK', symbol: 'Kč' };
      break;
    case 'hu':
      currencyInfo = { code: 'HUF', symbol: 'Ft' };
      break;
    case 'sk':
      currencyInfo = { code: 'EUR', symbol: '€' };
      break;
    default:
      break;
  }

  return currencyInfo;
};

export const getLocaleCurrencyInfo = (): CurrencyInfo => {
  const country = window.country || process.env.REACT_APP_COUNTRY;

  return getCurrencyInfo(country);
};
